
import React from 'react';
import _ from "lodash";

import NavBtnWidget from "../NavBtnWidget.jsx";

import {InputWidget, SingleSelectWidget, MultiSelectWidget, MaskedInputWidget, DateInputWidget} from '../../controls/widgets.jsx';
import * as C from "../../controls/constraints.jsx";


function notEmpty(v) {
    return (v !== undefined && v !== null && (v.length !== undefined ? v.length > 0 : true));
}


export default ({schema, data, onDataChanged}) => {
    const
        me = this,
        //
        onRepresentativeFieldChange = (index, value, field) => {
            let repr = data['representatives'] || this.getRepresentativesTemplate();

            repr[index][field] = value;

            (onDataChanged||function(){})({
                representatives: repr
            })
        },

        representatives = data['representatives'] || [],
        formValid = C.validateSchema(representatives, schema.child('representatives', representatives, data)),
        itemsSchema = schema.child('representatives', representatives, data);

        return (
            <form className="form">
                <div className="card card-primary">
                    <div className="card-header text-bg-primary">Законные представители</div>
                    <div className="card-body">
                        {!formValid.r ? (
                            <div className="alert alert-danger">Необходимо заполнить информацию минимум об одном законном представителе</div>
                        ) : (
                            <div className="alert alert-success">Вы можете дополнить информацию о законных представителях</div>
                        )}

                        <div className="form form-horizontal">
                            {_.map(representatives, function(v, k){
                                return (
                                    <div className="card border-default mt-2" key={k}>
                                        <div className="card-header text-bg-default">{v.status}</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="col-md-12">
                                                        <InputWidget
                                                            name="full_name"
                                                            title="Полное имя:"
                                                            vertical={true}
                                                            schema={itemsSchema}
                                                            data={v}
                                                            onChange={onRepresentativeFieldChange.bind(me, k)}
                                                            />
                                                    </div>
                                                </div>
                                                <div className="col-md-7">
                                                    <div className="col-md-12">
                                                        <InputWidget
                                                            name="address_living"
                                                            title="Домашний адрес:"
                                                            vertical={true}
                                                            schema={itemsSchema}
                                                            data={v}
                                                            onChange={onRepresentativeFieldChange.bind(me, k)}
                                                            />
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="col-md-12">
                                                        <InputWidget
                                                            name="contact_phone"
                                                            title="Контактный телефон:"
                                                            vertical={true}
                                                            schema={itemsSchema}
                                                            data={v}
                                                            onChange={onRepresentativeFieldChange.bind(me, k)}
                                                            />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="col-md-12">
                                                        <InputWidget
                                                            name="work_organization"
                                                            title="Место работы:"
                                                            vertical={true}
                                                            schema={itemsSchema}
                                                            data={v}
                                                            onChange={onRepresentativeFieldChange.bind(me, k)}
                                                            />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="col-md-12">
                                                        <InputWidget
                                                            name="work_position"
                                                            title="Должность:"
                                                            vertical={true}
                                                            schema={itemsSchema}
                                                            data={v}
                                                            onChange={onRepresentativeFieldChange.bind(me, k)}
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <NavBtnWidget to="/more" />

            </form>
        );
    }
